const PRESCRIPTION_SORTING_ARRAY = [
  "power",
  "baseCurve",
  "diameter",
  "cylinder",
  "axis",
  "addition",
  "pupillaryDistance"
];
function sortPrescriptionParameters(paramNames) {
  const knownParams = paramNames.filter((p) => PRESCRIPTION_SORTING_ARRAY.includes(p));
  const unknownParams = paramNames.filter((p) => !PRESCRIPTION_SORTING_ARRAY.includes(p));
  const sortedParams = knownParams.sort(
    (a, b) => PRESCRIPTION_SORTING_ARRAY.indexOf(a) - PRESCRIPTION_SORTING_ARRAY.indexOf(b)
  );
  const sortedUnknownParams = unknownParams.sort();
  return [...sortedParams, ...sortedUnknownParams];
}
export {
  sortPrescriptionParameters
};
//# sourceMappingURL=sort-prescription-parameters.js.map
